'use client';

import { useEffect } from 'react';
import Clarity from '@microsoft/clarity';
import { CLARITY_PROJECT_ID } from '@/lib/constants';

export function ClarityProvider() {
  useEffect(() => {
    Clarity.init(CLARITY_PROJECT_ID);
  }, []);

  return null;
}
